export default __webpack_public_path__ + "static/media/razmernaya_setka_nizhnee_belye.5c729e8e.svg";